// extracted by mini-css-extract-plugin
module.exports = {"image":"_93444fe79c--image--3ua1b"};